

import React, { useEffect, useState } from "react";
import { Card, CircularProgress } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import MultiTag from 'components/MultiTag/amenities';
import { useDispatch, useSelector } from "react-redux";
import PdfImage from "assets/images/PDF.png"
import { BorderColor, DeleteForeverOutlined } from "@mui/icons-material";
import { baseURL } from "utils/api";
import { getAmenitiesData } from "api/commonSlice";
import toast from "react-hot-toast";

const SimpleForm = ({ data,handelRefresh }) => {

  const dispatch = useDispatch();
  const amenities = useSelector((state) => state.commonSlice?.amenities);
  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [oldFile, setOldFile] = useState({});
  const [madeChanges, setMadeChanges] = useState(false);
  const [loading, setLoading] = useState(false);
  const userTheme = useSelector((state) => state.commonSlice.theme);
  const [values, setValues] = useState({
    amenitiesId: [],
    reservationAllowed: false,
    file: null,
    userId: ""
  });

  useEffect(() => {
    dispatch(getAmenitiesData(data?.category?.id));
  }, [data]);

  useEffect(() => {
    setSelectedAmenities([]);
    if (data?.amenities) {
      setSelectedAmenities(data?.amenities)
    }
    setValues((prev) => ({
      ...prev,
      amenitiesId: data?.amenities?.map((item) => item?._id),
      reservationAllowed: data?.reservationAllowed,
      userId: data?._id
    })
    );


    fetch(`${baseURL}/get-file-url/${localStorage.getItem('id')}?businessId=${data?._id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setUploadedFile(data?.data?.fileUrl);
          setOldFile(data?.data)
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      }
      )
  }, [data]);


  // Handle file change
  const handleFileChange = (event) => {
    setMadeChanges(true);
    const file = event.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setErrorMessage("Invalid file type. Please upload a PDF file.");
        setUploadedFile(null);
        return;
      }
      if (file.size > 10485760) {
        setErrorMessage("File size exceeds 10MB. Please upload a smaller file.");
        setUploadedFile(null);
        return;
      }
      setUploadedFile(file);
      setErrorMessage("");
    }
  };



  // Handle Cancel
  const handleCancel = () => {
    setSelectedAmenities([]);
    setUploadedFile(null);
    setErrorMessage("");
  };

  const updateApi = (event) => {

    event.preventDefault();
    setLoading(true);
    if (selectedAmenities.length === 0) {
      setErrorMessage("Please select at least one amenity.");
      return;
    }
    
    const formdata = new FormData();
    uploadedFile&& formdata.append('file', uploadedFile);
    formdata.append('amenities', (values?.amenitiesId&&values?.amenitiesId.length>0)&&values?.amenitiesId.join(','));
    formdata.append('reservationAllowed', values.reservationAllowed);
    formdata.append('userId', localStorage.getItem('id'));
    formdata.append('businessId',data?._id);

    fetch(`${baseURL}/file`, {
      method: 'POST',
      headers: {
        Accept: 'application-json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: formdata
    })
      .then(res => res.json())
      .then(data => {
        setLoading(false);
        if (data.status === 200) {
         toast.success('Data Updated Successfully');
         handelRefresh()
        }else{
          toast.error('Data not Updated')
        }
      }).catch(err => {
        setLoading(false);
        toast.error(err.message || 'Something went wrong');
      });
  }

  const onChangeMultiTag = (event, value) => {
    setSelectedAmenities(value);
    setValues((prev) => ({
      ...prev,
      amenitiesId: value.map((item) => item?._id),
    }));
    setMadeChanges(true);
  };

  const handleDeleteFile = (e) => {

    e.preventDefault();
    setMadeChanges(true);
    setUploadedFile(null)
    fetch(`${baseURL}/deleteFile/${localStorage.getItem('id')}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res => res.json())
      .then(data => {
        if (data.status === 200) {
          setUploadedFile(null)
        }
      }).catch(err => {
        toast.error(err.message || 'Something went wrong');
      });
  };




  return (
    <SoftBox
      sx={{
        p: 3,
      }}
    >
      {/* Amenities Multi-Select */}
      <SoftTypography variant="caption" sx={{ color: "primary" }}>
        Select Amenities
      </SoftTypography>
      <SoftBox sx={{ mt: 2, }}>
        {amenities && amenities.length > 0 && <MultiTag
          data={amenities}
          value={selectedAmenities}
          onChange={onChangeMultiTag}
        />}
      </SoftBox>

      {/* File Upload Section */}
      <SoftTypography
        variant="h6"
        sx={{ fontWeight: "bold", color: "#1e88e5", mt: 3 }}
      >
        MENU/PRODUCT
      </SoftTypography>
      <SoftTypography variant="body2" sx={{ mb: 1 }}>
        Please upload your menu/product in PDF format.{" "}
        <b>(Only 1 PDF can be uploaded.)</b>
      </SoftTypography>
      <Card
        className="glassmorphism-card"
        sx={{
          border: "1px dashed #ccc",
          borderRadius: 2,
          p: 2,
          textAlign: "center",

        }}
      >
        <input
          id="pdfUpload"
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          style={{ display: "none" }}

        />
        <label htmlFor="pdfUpload">
          <SoftButton
            variant="outlined"
            component="span"
            sx={{
              textTransform: "none",
              color: userTheme=='dark'? "#ffffff":"#141414",
              border: userTheme=='dark'? "1px solid #ffffff":"1px solid #141414",
            }}
          >
            Browse for PDF
          </SoftButton>
        </label>
        <SoftTypography
          variant="body2"
          sx={{ mt: 1, }}
        >
          {uploadedFile
            ? <SoftBox
              mt={4}>
                <SoftBox
               href={uploadedFile}
               component="a"
              >
              <img
                style={{ width: "60px", height: "80px" }}
                src={PdfImage} alt="pdf" />
                </SoftBox>
              <SoftBox
                onClick={(e) => handleDeleteFile(e)}
                sx={{ cursor: "pointer", position: "relative", top: 0, right: 0,color: userTheme === 'dark' ? '#ffffff' : '#000000' }}

              >
                <DeleteForeverOutlined sx={{ fontSize: 30 }} />
              </SoftBox>
            </SoftBox>
            : "Only PDF files under 10MB are allowed."}
        </SoftTypography>
      </Card>

      {/* Error Message */}
      {errorMessage && (
        <SoftTypography variant="caption" color="error" sx={{ mt: 1 }}>
          {errorMessage}
        </SoftTypography>
      )}

      {/* Buttons */}
      <SoftBox sx={{ display: "flex", justifyContent: "space-between", mt: 3 }} gap={2}>
      <SoftButton
      fullWidth
          variant="outlined"
          color="info"
          onClick={handleCancel}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </SoftButton>
        <SoftButton
        fullWidth
          variant="gradient"
          color={madeChanges ? "info" : "light"}
          disabled={!madeChanges}
          onClick={updateApi}
          sx={{ textTransform: "none" }}
        >
          {
                       loading ? <CircularProgress size={24} color='white'/> : 'Save Changes'
                      }
        </SoftButton>
   
      </SoftBox>
    </SoftBox>
  );
};

export default SimpleForm;

